import { ContentWrapper, StyledButton } from "./styles";
import { MenuButtonsProps } from "./types/interfaces";

export const MenuButton = ({
  id,
  modalLabel,
  onClick,
  renderContent,
  size = "home",
  isSelected = false,
  disabled = false,
}: MenuButtonsProps) => {
  const handleClick = () => {
    if (isSelected) {
      return;
    }

    onClick();
  };

  return (
    <StyledButton
      ariaLabel={modalLabel ?? id}
      onClick={handleClick}
      isSelected={isSelected}
      disabled={disabled}
      $size={size}
      renderContent={(isHovered) => (
        <ContentWrapper>{renderContent(isSelected || isHovered)}</ContentWrapper>
      )}
    />
  );
};
